import { AuthGuard } from "@redotech/redo-customer-portal-app/contexts/auth";
import { Page } from "@redotech/redo-customer-portal-app/portal-four/shared-components/page";
import { Outlet, RouteObject } from "react-router-dom";

export const retailRoutes: RouteObject[] = [
  {
    element: (
      <AuthGuard>
        <Page>
          <Outlet />
        </Page>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        lazy: async () => {
          const { RetailActions } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-warranties-app/register/retail-actions");
          return { element: <RetailActions /> };
        },
      },
      {
        path: "register",
        lazy: async () => {
          const { Main: RegistrationPortal } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-warranties-app/register/main");
          return { element: <RegistrationPortal /> };
        },
      },
      {
        path: ":returnType",
        lazy: async () => {
          const { RetailReturnTypeMain } =
            // redont-allow-dynamic-import: route-level code splitting
            await import("@redotech/redo-customer-portal-warranties-app/register/retail-return-type-main");
          return { element: <RetailReturnTypeMain /> };
        },
      },
      {
        path: "registrations",
        children: [
          {
            path: ":id",
            lazy: async () => {
              const { RegisteredWarrantyDetails } =
                // redont-allow-dynamic-import: route-level code splitting
                await import("@redotech/redo-customer-portal-warranties-app/warranties/registered-warranty-details");
              return { element: <RegisteredWarrantyDetails /> };
            },
          },
        ],
      },
    ],
  },
];
